<template>
  <!-- + '/' + coupon -->
  <form
    :action="action"
    :class="'checkout-form-'+ plan + device_id"
    method="POST"
  >
    <!-- <%= label_tag(:couponCode, 'Coupon:') %>
    <%= text_field_tag(:couponCode) %>-->
    <!-- <label for="couponCode">Coupon:</label>
    <input type="text" id="couponCode" style="border: 1px solid grey" v-model="coupon"> -->
    <input type="hidden" :value="amount" name="amount">
    <label>
      <span :text="amount"/>
    </label>
  </form>
</template>

<script>
import axios from "axios";
export default {
  name: "charge-btn",

  props: {
    device_id: [String, Number],
    email: {type: String, required: false},
    amount: [String, Number],
    currency: [String, Number],
    stripeKey: [String, Number],
    promo: [String, Number],
    plan: {
      type: String,
      required: false
    }
  },

  data: () => ({
    action: ''
  }),

  created() {
    this.init()
    this.$forceUpdate()
  },

  methods: {
    init() {
      axios.get(this.$hostname + "/client/me/", {
        headers: {
          Authorization: localStorage.getItem("token")
        }
      })
      .then(response => {
        this.action = this.$hostname + '/stripe/charge/' + response.data.data.email + '/' + this.device_id
        if (this.promo) {
          this.action += '/' + this.promo
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.disabled {
  filter: grayscale(1);

  button {
    cursor: default !important;
  }
}
</style>

<style lang="scss">
button.stripe-button-el {
  background-image: none;
  border-radius: 2px;
  will-change: box-shadow;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  color: #fff;
  text-transform: uppercase;
  font-family: "MuseoSansCyrillic";
  background-color: #800057;
  border-color: #800057;
  border: none;
  padding: 0;
  span {
    background-image: none;
    border-radius: 2px;
    font-family: "MuseoSansCyrillic";
    background-color: #800057;
    border-color: #800057;
    font-size: 14px;
    font-weight: 500;
    padding: 0 16px;
    height: 36px;
    line-height: 36px;
    border: none;
  }
}
</style>

